// @flow
import './default-bundle';

import DiamondCatalog from '@components/pages/diamonds/Catalog';
import DiamondNotFound from '@components/pages/diamonds/NotFound';
import DiamondDetail from '@components/containers/DiamondDetail';

ReactOnRails.register({
  DiamondCatalog,
  DiamondDetail,
  DiamondNotFound
});
